var exports = {
  "qS": "MentionBadge.module__badge___Z2xaaj",
  "ZN": "MentionBadge.module__badgeSmall___Z2xaaj",
  "N1": "MentionBadge.module__badgeMedium___Z2xaaj",
  "x5": "MentionBadge.module__animatedWrapper___Z2xaaj",
};

module.exports = exports;
